import { jsx as _jsx } from "react/jsx-runtime";
import { Listbox, ListboxOption } from '@criteria-labs/react';
export function ContentTypePicker({ contentTypes, selectedContentType, onChange }) {
    return (_jsx(Listbox, { value: selectedContentType !== null && selectedContentType !== void 0 ? selectedContentType : undefined, onChange: onChange, small: true, children: contentTypes.map((contentType) => (_jsx(ListboxOption, { value: contentType, children: contentType }))) }));
}
